import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { useRefetchOnReturn } from "Hooks/useRefetchOnReturn";
import { generateDisplayFields } from "utils/fieldMapper";
import { getHeroSections, deleteHeroSection } from "adminApi/WebsiteSettingsApi/HeroSectionApi";
import { FilterStatus } from "utils/FilterStatus";
import fields from "../../json/HeroSectionListFields.json";


const HeroSectionListTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields;

  // Fetch data hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(getHeroSections, {
    page,
    limit,
    search: debouncedSearch,
    title: "Hero Sections",
  });

  // Auto refetch when returning from edit/add pages
  useRefetchOnReturn(refetch, 'heroSection');


  const displayFields = generateDisplayFields(tabledata);
  const filterdata = FilterStatus(data);

  // Table config hook
  const { formattedData, columns } = useTableConfig({
    data: filterdata,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Hero Section",
      editUrl: "edit-hero-section",
      idKey: "id",
      deleteApi: deleteHeroSection,
      displayFields,
    },
  });

  // Handlers
  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);
  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default HeroSectionListTable;
